import * as React from "react";
import { CategorizedPageHelpRegistration, RenderRegistrationCardProps } from "../../../Registry/pageHelpRegistry";
import pageIds from "pageIds";
import { CommonConfigurationUserOverview, CommonConfigurationUserTopics } from "../../CommonComponents/CommonConfigurationUserViews";

export const ConfigurationUserRegistration: CategorizedPageHelpRegistration = {
    page: pageIds.configuration.user,
    renderOverview: (renderProps: RenderRegistrationCardProps) => {
        return <CommonConfigurationUserOverview />;
    },
    renderTopics: (renderProps: RenderRegistrationCardProps) => {
        return <CommonConfigurationUserTopics />;
    }
};
